import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import _typeof from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/typeof";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/createClass";
export function version(supportedVersion) {
  var include = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return function (target, key, descriptor) {
    var oldValue = descriptor.value;

    descriptor.value = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (!this.getVersion) {
        return oldValue.apply(this, args);
      }

      var appVersion = this.getVersion();

      if (appVersion.compare(supportedVersion, include)) {
        return oldValue.apply(this, args);
      }

      throw new UnsupportedVersionError("".concat(key, " is unsupported for ").concat(appVersion, "(supported from: ").concat(supportedVersion, ")"));
    };

    return descriptor;
  };
}
export var UnsupportedVersionError = /*#__PURE__*/function () {
  function UnsupportedVersionError() {
    var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'api is unsupported for this version';

    _classCallCheck(this, UnsupportedVersionError);

    this.code = -10000;
    this.msg = msg;
  }

  _createClass(UnsupportedVersionError, [{
    key: "toString",
    value: function toString() {
      return "".concat(this.msg, "(").concat(this.code, ")");
    }
  }]);

  return UnsupportedVersionError;
}();
export function retry() {
  var times = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
  var interval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
  return function (target, key, descriptor) {
    var oldValue = descriptor.value;
    descriptor.value = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this = this;

      var _len2,
          args,
          _key2,
          err,
          lastReqTime,
          _loop,
          i,
          _ret,
          _args2 = arguments;

      return regeneratorRuntime.wrap(function _callee$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              for (_len2 = _args2.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = _args2[_key2];
              }

              _context2.prev = 1;
              lastReqTime = Date.now();
              _context2.next = 5;
              return oldValue.apply(this, args);

            case 5:
              return _context2.abrupt("return", _context2.sent);

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);

            case 10:
              _loop = /*#__PURE__*/regeneratorRuntime.mark(function _loop(i) {
                return regeneratorRuntime.wrap(function _loop$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return delay(function () {
                          var currReqTime = Date.now();
                          console.log("retry ".concat(i + 1, " times, ").concat(currReqTime - lastReqTime, " milliseconds since last request"));
                          lastReqTime = currReqTime;
                          return oldValue.apply(_this, args);
                        }, interval)();

                      case 3:
                        _context.t0 = _context.sent;
                        return _context.abrupt("return", {
                          v: _context.t0
                        });

                      case 7:
                        _context.prev = 7;
                        _context.t1 = _context["catch"](0);
                        err = _context.t1;

                      case 10:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _loop, null, [[0, 7]]);
              });
              i = 0;

            case 12:
              if (!(i < times)) {
                _context2.next = 20;
                break;
              }

              return _context2.delegateYield(_loop(i), "t1", 14);

            case 14:
              _ret = _context2.t1;

              if (!(_typeof(_ret) === "object")) {
                _context2.next = 17;
                break;
              }

              return _context2.abrupt("return", _ret.v);

            case 17:
              i++;
              _context2.next = 12;
              break;

            case 20:
              throw err;

            case 21:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee, this, [[1, 8]]);
    }));
    return descriptor;
  };
}

function delay(fn, milliseconds) {
  return function () {
    var _this2 = this;

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return new Promise(function (resolve, reject) {
      setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return fn.apply(_this2, args);

              case 3:
                res = _context3.sent;
                resolve(res);
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);
                reject(_context3.t0);

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee2, null, [[0, 7]]);
      })), milliseconds);
    });
  };
}